var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpeed15 = function SvgSpeed15(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 7 16V9H6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 5 8q0-.424.287-.713A.97.97 0 0 1 6 7h1q.824 0 1.412.588Q9 8.175 9 9v7q0 .424-.287.712A.97.97 0 0 1 8 17m6 0a.97.97 0 0 1-.713-.288A.97.97 0 0 1 13 16q0-.424.287-.713A.97.97 0 0 1 14 15h3v-2h-2q-.825 0-1.412-.588A1.93 1.93 0 0 1 13 11V9q0-.825.588-1.412A1.93 1.93 0 0 1 15 7h3q.424 0 .712.287Q19 7.576 19 8q0 .424-.288.713A.97.97 0 0 1 18 9h-3v2h2q.824 0 1.413.588Q19 12.175 19 13v2q0 .824-.587 1.413A1.93 1.93 0 0 1 17 17zm-3 0a.97.97 0 0 1-.713-.288A.97.97 0 0 1 10 16q0-.424.287-.713A.97.97 0 0 1 11 15q.424 0 .713.287.287.288.287.713 0 .424-.287.712A.97.97 0 0 1 11 17"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpeed15);
export { ForwardRef as ReactComponent };